<template>
  <div class="miya-layout">
    <div class="miya-layout-content">
      <miya-menu></miya-menu>
      <div class="miya-content">  
        <router-view></router-view>
      </div>
      <user-info></user-info>  
    </div>
    <contact class="miya-layout-contact"></contact>
  </div>
</template>
<script>
import miyaMenu from '@components/miyaMenu.vue'
import userInfo from '@components/userInfo.vue'
import contact from '@components/contact.vue'
import {mapGetters, mapActions} from 'vuex'
export default {
  data () {
    return {
    }
  },
  created () {
    this.getUserInfo()
  },
  methods: {
    getUserInfo () {  
      this.$get(`/Check/GetInfo`).then(res => {
        if (res.code === 200) {
          this.$store.commit('set_user', res.result)
        }
      })
    },
  },
  beforeDestroy () {
  },
  components: {miyaMenu, userInfo, contact}
}
</script>
<style scoped lang="stylus">
.miya-layout
  width 100%
  height 100vh
  overflow-y auto
  .miya-layout-content
    display flex
    min-height 920px
    height 100%
    .miya-content
      flex 1
      height 100%
      overflow hidden
  .miya-layout-contact
    bottom 5%
    right 24px
@media screen and (max-width: 800px)
  .miya-layout
    .miya-layout-content
      min-height 100vh
      // overflow-x hidden
      .miya-content
        margin-top 2.6rem
        height calc(100% - 2.6rem)
        background-color #FCFBFA
</style>
<style lang="stylus">
@media screen and (max-width: 1640px)
  .miya-layout
    .miya-layout-content
      .miya-content
        .pageBox
          padding 20px 24px
@media screen and (max-width: 800px)
  .miya-layout
    .miya-layout-content
      .miya-content
        .pageBox
          padding 1rem
        .title1
          font-size 1rem
</style>